
import { BarChart, AreaChart, Bar, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';

const AreaChartParachute = ({data, xLabel, yLabel, yDisplay}) => {

return (
    <ResponsiveContainer width="100%" height={300}>
    <AreaChart 
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
    >
        <defs>
        <linearGradient id="jobsGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.4}/>
            <stop offset="95%" stopColor="#4f46e5" stopOpacity={0.05}/>
        </linearGradient>
        </defs>
        <CartesianGrid 
            strokeDasharray="3 3" 
            stroke="#f1f5f9" 
            vertical={false}
        />
        <XAxis 
            dataKey={xLabel}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
        />
        <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
        />
        <Tooltip 
            contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
            }}
            cursor={{ stroke: '#4f46e5', strokeWidth: 2, strokeOpacity: 0.3 }}
        />
        <Area
            type="monotone"
            dataKey={yLabel}
            stroke="#4f46e5"
            strokeWidth={3}
            fill="url(#jobsGradient)"
            dot={{ fill: '#4f46e5', strokeWidth: 2, r: 5 }}
            activeDot={{ r: 8, stroke: '#4f46e5', strokeWidth: 3, fill: 'white' }}
        />
    </AreaChart>
    </ResponsiveContainer>
);
}
export default AreaChartParachute;